import { IRewardsTransactionsHistoryState } from '../../rewardsClub.interface';
import {
    RewardsTransactionsHistoryAction,
    RewardsTransactionsHistoryActionTypes,
} from './rewardsTransactionsHistoryActionType';

const initialState: IRewardsTransactionsHistoryState = {
    pointsEarned: null,
    pointsSpent: null,
    history: null,
    fetching: false,
    error: null,
};

export function rewardsTransactionsHistoryReducer(
    state = initialState,
    action: RewardsTransactionsHistoryAction,
): IRewardsTransactionsHistoryState {
    switch (action.type) {
        case RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_REQUEST:
            return { ...state, fetching: true };
        case RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_SUCCESS:
            const { pointsEarned, pointsSpent, history } =
                action.rewardsTransactionsHistoryResponse;
            return {
                ...state,
                fetching: false,
                pointsSpent: pointsSpent,
                pointsEarned: pointsEarned,
                history: history,
                error: null,
            };
        case RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_FAILURE:
            return {
                ...state,
                error: action.error,
                fetching: false,
                pointsEarned: 0,
                pointsSpent: 0,
                history: null,
            };
        default:
            return state;
    }
}
